import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 3,
  class: "absolute inset-0 flex items-center justify-center"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TwButton',
  props: { 
		loading: {
			type: Boolean,
			default: false
		},
		rounded: {
			type: Boolean,
			default: false
		} 
	},
  setup(__props) {

//eslint-disable-next-line
    const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: _normalizeClass(["button relative", { 'rounded-full': __props.rounded }])
  }, [
    (_ctx.$slots.icon)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass(["btn-icon", {'mx-0': !_ctx.$slots.default, invisible: __props.loading}]),
          "aria-hidden": "true"
        }, [
          _renderSlot(_ctx.$slots, "icon")
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.$slots.default)
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: _normalizeClass({invisible: __props.loading})
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.$slots.icon_right)
      ? (_openBlock(), _createElementBlock("span", {
          key: 2,
          class: _normalizeClass(["btn-icon btn-icon-right", {'mx-0': !_ctx.$slots.default, invisible: __props.loading}]),
          "aria-hidden": "true"
        }, [
          _renderSlot(_ctx.$slots, "icon_right")
        ], 2))
      : _createCommentVNode("", true),
    (__props.loading)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _cache[0] || (_cache[0] = [
          _createElementVNode("svg", {
            class: "animate-spin h-5 w-5",
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 24 24"
          }, [
            _createElementVNode("circle", {
              class: "opacity-25",
              cx: "12",
              cy: "12",
              r: "10",
              stroke: "currentColor",
              "stroke-width": "4"
            }),
            _createElementVNode("path", {
              class: "opacity-75",
              fill: "currentColor",
              d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            })
          ], -1)
        ])))
      : _createCommentVNode("", true)
  ], 2))
}
}

})